import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import TermsAndConditions from "../legal/TermsAndConditions"


class TC extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Modal id="tc" show={this.props.show} onHide={this.props.onHide} centered>
        <Modal.Header style={{ marginBottom: "2rem" }} closeButton>
          <Modal.Title style={{ fontWeight: 700 }}>
            <Translate value="accountDetails_termAndCond" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div style={{ maxHeight: "calc(70vh - 4.5rem)", overflowY: "auto" }}>
            We are committed to communicating with you in a professional manner and protecting your
            confidential information. We use the information you provide (e.g. name, address, phone
            number, email, etc.) to contact you to share information about our (products/services).
            We will not share your information with any third party outside of our organization,
            other than as necessary to fulfill your request. This company does not sell, trade or
            rent your personal information to others. Please contact us to correct or update
            information at any time at 1-800-545-1403. Back Office (including Backoffice.co, Inc and
            its affiliates) respects your privacy and is committed to protect the personal
            information of its visitors browsing the site ("Users"). We believe that you have a
            right to know our practices regarding the information we may collect when you visit
            and/or use our website [http://www.backoffice.com] (the "Site"). This policy explains
            our privacy practices for the Site and services provided by Back Office. By accessing
            and/or using the Site and its related sites, applications, services, goods and/or
            registering for a Back Office account, you consent to the terms and conditions of this
            privacy policy, including to our collection, use, disclosure, processing and retention
            of your personal information. You can also learn how to limit sharing of information in
            this policy. Information we collect When you register to the Site we ask you to provide
            certain personal information, including a valid email address, location and username. We
            may collect additional information such as physical address and additional
            authentication information, to provide you with the services you need. We collect
            information to provide better services and enhanced user experience to all of our Users.
            In addition, we collect information while you access, browse, view or otherwise use the
            Site. In other words, when you access the Site we are aware of your usage of the Site,
            and may gather, collect and record the information relating to such usage, including
            geo-location information, IP address, device and connection information, browser
            information and web-log information, and all communications recorded by Users through
            the Site. We use that information to enhance user experience, personalize your browsing
            experience as well as monitor the Site for fraud and inappropriate content or behavior.
            We may also collect supplemental information obtained from third parties such as
            demographic and navigation data. Additionally, in order to improve your online
            experience at Back Office, we have implemented impression reporting. While you view our
            ads, we may gather user Global Unique Identifier, http request data like, user agent,
            ip, host, url, country/continent from which request made, browser info, device/operating
            system/operating system version. We retain information as long as it is necessary and
            relevant for our operations. In addition, we may retain personal information from closed
            accounts to comply with the law, prevent fraud, collect any fees owed, resolve disputes,
            troubleshoot problems, assist with any investigation, enforce our Site terms and take
            other actions permitted by law. Sharing personal information with third parties We do
            not sell or rent your personal information to third parties for their marketing purposes
            without your explicit consent. We may combine your personal information with information
            we collect automatically or obtain from other companies and use it to improve and
            personalize our services, content and advertising. If you do not wish to receive
            marketing communications from us, you can opt-out through the link attached to each
            communication or by calling us at 1-800-711-3307.
          </div> */}
          <TermsAndConditions/>
        </Modal.Body>
      </Modal>
    );
  }
}

export default TC;
